import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom'; // Correct import for useLocation
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import { Link } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ProductContext } from "../context/AppContext";
import Footer from './Common_Components/Footer';
function NextQuiz() {
    const navigate = useNavigate();
    const location = useLocation();
    const [activePage, setActivePage] = useState("Learning");
    // Use useLocation hook correctly
    const title = location.state?.title || "Day Module";
    // const { dayId, categoryId, incorrectAnswerIds, dayName, skitname, dayLen } = route.params
    const NextQuiz = location.state;
    const dayId = NextQuiz?.dayId;
    const categoryId = NextQuiz?.categoryId;
    const incorrectAnswerIds = NextQuiz?.incorrectAnswerIds;
    const dayName = NextQuiz?.dayName;
    const skitname = NextQuiz?.skitname;
    const dayLen = NextQuiz?.dayLen;
    const imageURL = NextQuiz?.imageURL;
    console.log("Next Quiz Screen Data :", dayId, categoryId, incorrectAnswerIds, dayName, skitname, dayLen, imageURL);
    const [language, setLanguage] = useState('english');
    const [text, setText] = useState({});
    const authToken = localStorage.getItem("AuthToken");
    const { Translate } = useContext(ProductContext);

    useEffect(() => {
        const loadLanguage = async () => {
            try {
                const storedLanguage = await localStorage.getItem('selectedLanguage');
                setLanguage(storedLanguage || 'english');
            } catch (error) {
                console.error('Error loading language:', error);
            }
        };

        loadLanguage();
    }, []);



    // useEffect(() => {
    //     setText(translations[language]);
    // }, [language]);


    // console.log("this is day id: " + dayId)
    // console.log("this is category id: " + categoryId)
    // console.log("this is incorrect anser ids on next skit: " + incorrectAnswerIds)


    const [imageUrl, setImageUrl] = useState('');
    const [loading, setLoading] = useState(true);


    // console.log("this is day id on next skit: " + dayId)


    const reachedLast = () => {
        return dayId > dayLen
    }

    // const handleReattempt = async () => {
    //     try {
    //         const response = await axios.get(`https://api.japaking.online/api/skit-questions?questionIds=${incorrectAnswerIds}`)
    //         if (response.data.success) {
    //             console.log("this is response data  ", response.data.message.question)
    //         }
    //     } catch (err) {
    //         console.log(err)
    //     }
    // }

    useEffect(() => {
        const fetchImage = async () => {
            try {
                const response = await axios.get(`https://api.japaking.online/api/skit-day?categoryId=${categoryId}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${authToken}`,
                        },
                    });

                if (response.data.success) {
                    const day = response.data.message.days.find(day => day.day_id === dayId);
                    if (day) {
                        setImageUrl(day.url);
                    }
                }
            } catch (err) {
                if (err.response && err.response.status === 401) {
                    console.log("navigate to login due to 401");
                    navigate("Login");
                }
                console.error('Error fetching image:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchImage();

        // const imgInterval = setTimeout(fetchImage, 1000);

        // return () => clearTimeout(imgInterval)

    }, [dayId, categoryId]);
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const SelectLanguageLocal = localStorage.getItem("selectedLanguage");

    return (
        <div className="JapaneseHSchoolDay1 d-flex flex-column" style={{ minHeight: '100vh' }}>
            <div className='header_inner' >
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ArrowBackIosIcon onClick={() => navigate(-1)} className='icon_1' />
                            <h2>{Translate?.message?.data?.nextQuiz || "Next Quiz"}</h2>
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="tiles-wrapper">
                <main className="JHS-content">
                    <div className="next-quiz-image-container">
                        <img
                            src={loading ? `${process.env.PUBLIC_URL}/assets/images/loading.jpg` : imageUrl}
                            alt={loading ? "Loading" : "Penguin"}
                            className="next-quiz-image"
                        />
                    </div>
                    <div className="next-quiz-button-container">
                        <button
                            className="JHS-action-button"
                            onClick={() =>
                                navigate("/JapaneseHSchoolDay1", {
                                    state: {
                                        categoryId,
                                        dayId: dayId + 1,
                                        dayName: dayId,
                                        skitname,
                                    },
                                })
                            }
                        >
                            {Translate?.message?.data?.moveToNextDay || "Move to Next Day"}
                        </button>
                        <button
                            className="JHS-action-button"
                            onClick={() =>
                                navigate("/ReattemptQuestion", {
                                    state: {
                                        reattemptids: incorrectAnswerIds,
                                        dayName,
                                        skitname,
                                        categoryId,
                                        dayId,
                                    },
                                })
                            }
                        >
                            {Translate?.message?.data?.reattempt || "Reattempt"}
                        </button>

                    </div>
                </main>

            </div>
      <Footer />
    </div>
  );
}
export default NextQuiz;
